import type { HomepageSection } from "../store/types";

export const MOCK_HOMEPAGE_SECTIONS: HomepageSection[] = [
  // ─── HERO ──────────────────────────────────────────────────────────────────
  {
    id: "hp-hero-main",
    section_key: "hero",
    title_zh: "記錄你的旅途",
    title_en: "Capture Your Journey",
    title_ja: "旅の記憶を",
    content_zh: "與在地獨立攝影師合作，留下真實動人的影像故事",
    content_en: "Connect with independent local photographers for authentic storytelling",
    content_ja: "地元の独立フォトグラファーと繋がり、本物のストーリーを残しましょう",
    image_url:
      "https://public.readdy.ai/ai/img_res/c80f57a88eeebe91c52a590f3c269ca0.jpg",
    is_active: true,
    sort_order: 1,
  },
  {
    id: "hp-hero-tagline",
    section_key: "hero",
    title_zh: "在日本",
    title_en: "in Japan",
    title_ja: "日本で刻む",
    content_zh: "開始你的故事",
    content_en: "Begin Your Story",
    content_ja: "ストーリーを始める",
    image_url: "",
    is_active: true,
    sort_order: 2,
  },
  // ─── PHILOSOPHY PAGE ───────────────────────────────────────────────────────
  {
    id: "hp-phil-hero",
    section_key: "philosophy",
    title_zh: "攝影，不是旅遊套餐",
    title_en: "Photography, Not Packaging",
    title_ja: "写真であり、パッケージではない",
    content_zh: "我們的存在是為了連結人與真實的故事敘述者，而非銷售觀光行程。",
    content_en: "We exist to connect people with authentic storytellers — not to sell tours.",
    content_ja: "私たちは、人と本物のストーリーテラーを繋ぐために存在しています。観光ツアーを売るためではありません。",
    image_url:
      "https://readdy.ai/api/search-image?query=Japan%20Kyoto%20beautiful%20photographer%20silhouette%20misty%20morning%20temple%20garden%20soft%20backlight%20cinematic%20film%20grain%20low%20saturation%20moody%20atmospheric%20emotional%20photography%20minimal%20aesthetic%20zen&width=1920&height=900&seq=philosophy-hero-1&orientation=landscape",
    is_active: true,
    sort_order: 0,
  },
  {
    id: "hp-phil-s1",
    section_key: "philosophy",
    title_zh: "我們是誰",
    title_en: "What We Are",
    title_ja: "私たちについて",
    content_zh: "TaBiFoTo 是一個預訂平台，連結旅人與日本各地的獨立攝影師。我們不是旅行社，不銷售行程、套裝商品，或包含交通與住宿的體驗包。",
    content_en: "TaBiFoTo is a booking platform that connects travelers with independent local photographers across Japan. We are not a travel agency. We do not sell tours, packages, or experiences bundled with transportation or accommodation.",
    content_ja: "TaBiFoToは、旅行者と日本各地の独立フォトグラファーを繋ぐ予約プラットフォームです。旅行代理店ではなく、ツアーや交通・宿泊を含むパッケージは一切販売しておりません。",
    image_url: "",
    is_active: true,
    sort_order: 1,
  },
  {
    id: "hp-phil-s2",
    section_key: "philosophy",
    title_zh: "獨立攝影師",
    title_en: "Independent Photographers",
    title_ja: "独立フォトグラファー",
    content_zh: "平台上的每位攝影師都是獨立承包人，擁有自己的創作視角、在地知識與專業技能。我們不雇用攝影師，我們放大他們的聲音。",
    content_en: "Every photographer on our platform is an independent contractor who brings their own creative vision, local knowledge, and professional skill. We do not employ photographers — we amplify them.",
    content_ja: "プラットフォームのすべてのフォトグラファーは、独自の創造的ビジョン、地元の知識、プロのスキルを持つ独立契約者です。私たちはフォトグラファーを雇用するのではなく、その声を広げます。",
    image_url: "",
    is_active: true,
    sort_order: 2,
  },
  {
    id: "hp-phil-s3",
    section_key: "philosophy",
    title_zh: "我們販售什麼",
    title_en: "What We Sell",
    title_ja: "私たちが販売するもの",
    content_zh: "我們販售與攝影師共度的時光。一項技能。一門藝術。誠實而美好地被保存。沒有追加銷售，沒有捆綁，沒有混淆你所得到的。",
    content_en: "We sell time with a photographer. One skill. One craft. Preserved honestly and beautifully. No upsells, no bundles, no confusion about what you're getting.",
    content_ja: "私たちはフォトグラファーと過ごす時間を販売します。一つのスキル。一つの技術。誠実に美しく保存されます。アップセルなし、バンドルなし、曖昧さなし。",
    image_url: "",
    is_active: true,
    sort_order: 3,
  },
  {
    id: "hp-phil-s4",
    section_key: "philosophy",
    title_zh: "瞬間，而非地標",
    title_en: "The Moment, Not the Monument",
    title_ja: "モニュメントではなく、瞬間",
    content_zh: "日本不缺乏標誌性景點。真正稀有的，是那個懂得在擁擠街道間尋找靜謐光線的人——而我們的攝影師正是如此。",
    content_en: "Japan has no shortage of iconic locations. What's rare is someone who knows how to find the quiet light between crowded streets — and that's exactly who our photographers are.",
    content_ja: "日本には象徴的な場所が無数にあります。本当に希少なのは、混雑した街の片隅に静かな光を見つけられる人です——それが私たちのフォトグラファーです。",
    image_url: "",
    is_active: true,
    sort_order: 4,
  },
  // ─── CTA ───────────────────────────────────────────────────────────────────
  {
    id: "hp-cta-main",
    section_key: "cta",
    title_zh: "準備好創造回憶了嗎？",
    title_en: "Ready to Create Memories?",
    title_ja: "思い出を作る準備はできましたか？",
    content_zh: "開始預訂，我們將為你媒合最適合的攝影師。",
    content_en: "Start your booking and we'll connect you with the perfect photographer.",
    content_ja: "予約を始めて、最適なフォトグラファーをご紹介します。",
    image_url: "",
    is_active: true,
    sort_order: 1,
  },
];
